import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    img: {
        verticalAlign: "middle",
        marginLeft: "8px",
        marginRight: "8px"
    }
})